export enum Step {
  Loading,
  AccomodationType,
  Amount,
  OtherAmount,
  Cards,
  Children,
  CitizenshipNonDanish,
  CoApplicant,
  ContactInfo,
  HabitationYear,
  HasCoApplicant,
  Maritalstatus,
  Employment,
  PeriodOfRepayment,
  PersonalInformation,
  StatusAndQuote,
  Conditions,
  Citizenship,
  Purpose,
  CoApplicantIncome,
  ConsolidateLoan,
  Expenses,
  Income,
  Payout,
  WantConsolidateLoan
}